import {Button} from "@mui/material";
import {Grid} from "@mui/system";
import React from "react";
import {useNavigate} from "react-router-dom";
import style from "../../assets/css/home.module.scss";
import {isMobile, isMobileOnly} from "react-device-detect";
import deskBanner from "../../assets/img/home/Banner.webp";

function Banner() {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={style.suryaHomeSlider}
        style={{
          backgroundImage: `url(${isMobileOnly ? deskBanner : deskBanner})`,
        }}
      >
        <div className={style.suryaHomeImg}>
          <Grid
            container
            maxWidth="xl"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid size={{xs: 12, lg: 12, md: 12}}>
              <div className={style.suryaHomeBannerText}>
                <h1 className={style.suryaHomeBannerTitle}>
                  Jewelry Insurance with <br /> Years of Expertise
                </h1>
                <p className={style.suryaHomeBannerDescription}>
                  The trusted jewelry insurer protecting multiple customers{" "}
                  {isMobile ? "" : <br />}
                  and backed by consumer confidence.
                </p>
                <Button
                  variant="outline"
                  className={style.banner_btn}
                  onClick={() => navigate("/login")}
                >
                  Get Started
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default Banner;
